import type { ButtonHTMLAttributes, ReactNode } from "react";
import { LoadingIcon } from "../icons/LoadingIcon";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "outline"
  | "ghost"
  | "danger";
export type ButtonSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  /** Shows a spinner before the label and blocks interaction (Figma
   * "States" rows, nodes 114:8549 / 119:3490). */
  loading?: boolean;
}

export function Button({
  variant = "primary",
  size = "md",
  iconLeft,
  iconRight,
  loading = false,
  disabled,
  className,
  children,
  type = "button",
  ...rest
}: ButtonProps) {
  const classes = [
    "ds-button",
    `ds-button--${variant}`,
    `ds-button--${size}`,
    loading ? "ds-button--loading" : undefined,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <LoadingIcon className="ds-button__spinner" width={14} height={14} />
      ) : (
        iconLeft
      )}
      {children}
      {iconRight}
    </button>
  );
}
